import { render, staticRenderFns } from "./fault-status-row.vue?vue&type=template&id=f20a255e&"
import script from "./fault-status-row.vue?vue&type=script&lang=ts&"
export * from "./fault-status-row.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports